<template>
    <div>
        <div class="kgr-inputIcon">
            <input
                type="text"
                class="kgr-input"
                :value="searchString"
                @input="searchString = $event.target.value;filterOptions()"
                @focus="showOptions = true"
                @focusout="closeOptionList"
            />
            <kgr-icon
                icon-class="search"
                small
                class="kgr-inputIcon__icon"
            />
        </div>
        <kgr-loading
            v-if="loading"
            inline
        />
        <div class="filterResults">
            <ul
                v-if="showOptions && searchRequirementsGiven && filteredOptions.length > 0"
                class="kgr-select"
                :size="selectSize"
            >
                <li
                    v-for="option in filteredOptions"
                    class="kgr-select__option"
                    @click="selection = option;update()"
                >
                    <slot :option="option"></slot>
                </li>
            </ul>
        </div>
        <div
            v-if="!loading && !searchRequirementsGiven"
            class="kgr-inputGroup__text"
        >
            {{ $t('Geben Sie mindestens %{min} Zeichen ein.', {'min': minSearchCharsThreshold}) }}
        </div>
        <div
            v-if="searchRequirementsGiven && noResults"
            class="kgr-inputGroup__text"
        >
            {{ $t('Es wurde keine Ergebnisse gefunden') }}
        </div>
    </div>
</template>

<script>

import Icon from '../../icon/Icon';
import Loading from '../../Loading';

export default {
    components: {
        'kgr-loading': Loading,
        'kgr-icon': Icon,
    },
    props: {
        options: {
            type: Array,
            required: false,
        },
        preFilteredOptions: {
            type: Array,
            required: false,
        },
        display: {
            type: String,
            required: false,
        },
        selectSize: {
            type: Number,
            required: false,
            default: 7,
        },
        search: {
            type: String,
            required: false,
            default: '',
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        minSearchCharsThreshold: {
            type: Number,
            required: false,
            default: 3,
        }
    },
    data() {
        return {
            selection: null,
            filteredOptions: [],
            searchString: '',
            showOptions: false,
        }
    },
    computed: {
        searchRequirementsGiven() {
            return this.searchString.length >= this.minSearchCharsThreshold;
        },
        noResults() {
            return !this.loading && (!this.filteredOptions || !this.filteredOptions.length) && (!this.preFilteredOptions || !this.preFilteredOptions.length);
        }
    },
    watch: {
        options() {
            if (null !== this.selection && !this.options.includes(this.selection)) {
                this.selection = null;
                this.update();
            }
        },
        preFilteredOptions() {
            if(this.preFilteredOptions) {
                this.showOptions = true;
                this.filteredOptions = this.preFilteredOptions;
            }
        }
    },
    mounted() {
        this.searchString = this.search;
    },
    methods: {
        //this is a workaround because the onfocusout would clode the list before an option could be selected
        //if you know a more elegant way to solve this please refactor :)
        closeOptionList() {
            setTimeout(function () {
                this.showOptions = false;
            }.bind(this), 200);
        },
        update() {
            this.searchString = this.selection !== null ? this.displayOption(this.selection) : '';
            this.$emit('input', this.selection);
            this.$nextTick(() => {
                this.$emit('post-input', this.selection);
            });
            this.filteredOptions = [];
            this.showOptions = false
        },
        filterOptions() {
            this.$emit('input', null);
            this.$nextTick(() => {
                this.$emit('post-input', null);
            });

            if(this.searchRequirementsGiven) {
                this.$emit('input:typing', this.searchString);
                if (this.options) {
                    this.filteredOptions = this.options.filter(option => this.displayOption(option).toLowerCase().indexOf(this.searchString.toLowerCase()) !== -1);
                    this.showOptions = this.filteredOptions.length !== 0;
                } else {
                    this.showOptions = false;
                }
            }
        },
        displayOption(option) {
            if (this.display) {
                return typeof option[this.display] === 'function' ? option[this.display]() : option[this.display];
            }

            return this.$t(option);
        }
    },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    select {
        position: absolute;
        width: auto;
        z-index: 1;
    }

    div.filterResults {
        position:absolute;
        max-height:200px;
        overflow-y: auto;
        z-index: 55;
    }

    ul li {
        line-height:2em;
        padding-left:0.5em;
        padding-right:0.5em;
        cursor:pointer;
        opacity:0.5;
    }
    ul li:hover {
        opacity:1;
    }

    @media only screen and (pointer: coarse) {
        .kgr-select[size]:not([size='1']) {
            height: initial;
        }
    }
</style>
